<template>
    <flex-element :element-type="elementType" class-default-inline="f-w-1/1" @dblclick="onEditHtml" />
</template>

<script>
import { mapMutations } from 'vuex';
import postscribe from 'postscribe';

import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { AHtml } from '@/data/data-models';
import listenOnRootMixin from '@/mixins/listen-on-root';
import { STATE_CLASSES } from '@/data/constants/classes';
import { SHOW_MODAL } from '@/store/types/mutation-types';

export default {
    name: 'a-html',
    mixins: [baseAtom, listenOnRootMixin],

    props: {
        displayName: {
            type: String,
            default: 'HTML',
        },

        richText: {
            type: String,
            default: '',
        },

        templateId: {
            type: String,
            default: '{4DCF91AE-CB0F-4C58-B0DF-1C8EF965D581}',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            richTextNew: '',
            isSelectorVisible: false,
            tempKey: 0,
        };
    },

    computed: {
        updatedElement() {
            return new AHtml({
                ...this.updatedBaseElement,
                richText: this.richTextNew,
            });
        },

        selectorClass() {
            return this.isSelectorVisible
                ? STATE_CLASSES.VISIBLE
                : STATE_CLASSES.HIDDEN;
        },

        renderHtml() {
            return this.richTextNew
                || (this.$slots.default ? this.$slots.default[0].text.trim() : '[HTML code here]');
        },
    },

    created() {
        this.listenOnRoot('flex::rich-text::save', this.onModalSave);
    },

    mounted() {
        postscribe(this.$el, this.renderHtml);
    },

    methods: {
        ...mapMutations({
            showModal: SHOW_MODAL,
        }),

        setFieldValues() {
            this.richTextNew = this.richText;
        },

        onEditHtml() {
            this.showModal({
                componentTag: 'rich-text-modal',
                data: {
                    elementId: this.id,
                    html: this.richTextNew,
                    rteType: 'htmlOnly',
                },
            });
        },

        onModalSave(id, html) {
            if (this.id !== id) return;

            this.richTextNew = html;
            this.tempKey += 1;
            this.setChangedData(true);
        },

        hideSelector() {
            this.isSelectorVisible = false;
        },

        showSelector() {
            if (this.selectedElements[0] !== this) {
                this.isSelectorVisible = true;
            }
        },
    },
};
</script>

<style lang="scss">
.e-html{
    position: relative;
}
</style>
